import i18n from '@/i18n';

export default {
  getListOfContractorOrAvatar(type, item) {
    const {
      contractor_status,
      name,
      user_factory_roles,
      user_factory_role_templates,
    } = item;
    if (type === 'contractor') {
      return contractor_status
        ? name
        : name + `(${i18n.t('合作終止')})`;
    } else {
      let itemText = name;
      let roleName = '';
      if (
        user_factory_roles &&
        user_factory_roles.length
      ) roleName = user_factory_roles.map(role => role.name).toString();
      if (
        user_factory_role_templates &&
        user_factory_role_templates.length
      ) {
        const templateRoleName = user_factory_role_templates.map(role => role.name).toString();
        if (roleName) roleName += `,${templateRoleName}`;
        else roleName = templateRoleName;
      }
      if (roleName) itemText = `${itemText}(${roleName})`;
      return itemText;
    }
  }
}